var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHomeGarage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 92,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-3.2%",
    y: "-3.8%",
    width: "106.4%",
    height: "110.8%",
    filterUnits: "objectBoundingBox",
    id: "icon-home-garage_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0",
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0",
    "in": "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-home-garage_svg__a)",
    transform: "translate(-164 -65)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264 146.5c0 1.933-21.268 3.5-47.5 3.5-26.235 0-47.5-1.567-47.5-3.5s21.265-3.5 47.5-3.5c26.232 0 47.5 1.567 47.5 3.5",
    fill: "#10C98F",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 92v-4.115c.12-.503 1.946-.885 2.976-.885h1.048c1.03 0 2.856.382 2.976.885V92M247 100v-5.125c0-1.032-.868-1.875-1.94-1.875H233",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229 128.002c0-1.106-.444-2.002-.998-2.002h-10c-.552 0-1.002.896-1.002 2.002V145h12v-16.998z",
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "#C3F1E3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241 128.002c0-1.106-.444-2.002-.998-2.002h-10c-.552 0-1.002.896-1.002 2.002V145h12v-16.998z",
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "#C3F1E3",
    opacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M209 88v57h40v-36.795z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 128.002c0-1.106-.852-2.002-1.912-2.002h-19.169c-1.057 0-1.919.896-1.919 2.002V145h23v-16.998z",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254 107.996c0 .693-.348 1.338-.918 1.704a1.9 1.9 0 01-1.891.09l-45.114-23.258A2.013 2.013 0 01205 84.738v-2.734c0-.693.348-1.341.927-1.705a1.887 1.887 0 011.888-.087l45.116 23.256a2.008 2.008 0 011.069 1.793v2.735z",
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "#C3F1E3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229 126v19M176 145h33v-40l-33 16.348z",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209 98l-36.925 18.53a1.988 1.988 0 00-1.075 1.775v2.71c0 .688.35 1.328.926 1.689.573.361 1.29.394 1.891.087L209 105.153V98z",
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "#C3F1E3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204 127.998c0-1.104-.859-1.998-1.917-1.998H182.92c-1.061 0-1.919.894-1.919 1.998V145h23v-17.002zM181 134h23M181 140h23",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.999 104a4.998 4.998 0 015.001 4.999 4.998 4.998 0 01-5.001 5.001 4.998 4.998 0 01-4.999-5.001 4.997 4.997 0 014.999-4.999z",
    stroke: "#076447",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 145v-6",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271 132.114c0 3.799-3.135 6.886-7 6.886-3.87 0-7-3.087-7-6.886 0-2.922 4.123-17.017 6.04-23.407.283-.943 1.634-.943 1.91 0 1.918 6.39 6.05 20.485 6.05 23.407z",
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "#C3F1E3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.837 74c-.403 0-.785.078-1.143.208-.4-2.383-2.562-4.208-5.194-4.208-2.625 0-4.788 1.825-5.194 4.208A3.254 3.254 0 00174.17 74c-1.752 0-3.171 1.345-3.171 3 0 1.658 1.419 3.001 3.17 3.001h12.667c1.75 0 3.163-1.343 3.163-3 0-1.656-1.415-3-3.163-3z",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))));
}
export default SvgIconHomeGarage;